export default __webpack_public_path__ + "static/media/globalCard1.b628c393.webp";